import createAxios from './../../axiosHttps';

export const importService = {
  downloadFile,
  getImports,
  getImportLogs,
  exportImportLogs,
};

const axiosInstance = createAxios();

function buildQueryUrl(basePath, query = {}) {
    const url = new URL(basePath, window.location.origin);
    const params = new URLSearchParams();

    // Agregar los parámetros a la URL
    Object.keys(query).forEach(key => {
        if (query[key] !== undefined && query[key] !== null) {
            params.append(key, query[key]);
        }
    });

    // Devolver la URL completa
    url.search = params.toString();
    return url.pathname + url.search;
}

async function getImports(filters, pagination, customerId) {
    const query = {
      page: pagination ? pagination.currentPage - 1 : 0,
      limit: pagination ? pagination.rows : 20,
      search: filters?.search,
      status: filters?.status,
      sort: filters?.sort?.sort ? filters?.sort?.sort : 'created_by',
      order: filters?.sort?.order ? filters?.sort?.order : 'ascending',
      warehouse: filters?.warehouse
    };
    
    const urlPath = buildQueryUrl(`/customer/${customerId}/import_data_files`, query);
    return await axiosInstance.get(urlPath).catch(handleError);
}

async function downloadFile(processId, filename, customerId) {
    const query = {
      filename: filename,
    };

    const urlPath = buildQueryUrl(`/customer/${customerId}/import_data_files/${processId}`, query);
    return await axiosInstance.get(urlPath, {responseType: 'blob'}).catch(handleError);
}

async function getImportLogs(processId, filters, pagination, customerId) {
    const query = {
      page: pagination ? pagination.currentPage - 1 : 0,
      limit: pagination ? pagination.rows : 20,
      search: filters?.search,
      log_type: filters?.logType,
      sort: filters?.sort?.sort ? filters?.sort?.sort : 'row_index',
      order: filters?.sort?.order ? filters?.sort?.order : 'ascending',
    };

    const urlPath = buildQueryUrl(`/customer/${customerId}/import_data_files/${processId}/logs`, query);
    return await axiosInstance.get(urlPath).catch(handleError);
}

async function exportImportLogs(processId, language, customerId) {
    const query = {
      language: language,
    };

    const urlPath = buildQueryUrl(`/customer/${customerId}/import_data_files/${processId}/logs/export`, query);
    return await axiosInstance.get(urlPath, {responseType: 'blob'}).catch(handleError);
}

function handleError(error) {
    console.error('API call failed:', error);
    throw axiosInstance;
}



//import createAxios from './axiosHttps';

function getBatchLoadsList(pagination,filters) {
  const axios = createAxios();
  const user= JSON.parse(localStorage.getItem("user"));
  let urlPath = `customer/${user.extraData.customerId}/import_data_files`;
  if (pagination) {
    urlPath += `?page=${pagination.currentPage - 1}&limit=${pagination.rows}`;
  } else {
    urlPath += '?page=0&limit=20';
  }
  if (filters && filters.search) {
    urlPath += `&search=${encodeURIComponent(filters.search)}`;
  }
  if (filters && filters.status) {
    urlPath += `&status=${filters.status}`;
  }
  if (filters && filters.sort) {
    if(filters.sort.sort){
      urlPath += `&sort=${filters.sort.sort}`;
    }
    if(filters.sort.order){
      urlPath += `&order=${filters.sort.order}`;
    }
  }
  return axios.get(urlPath);
}

function downloadResource(batch) {
  const axios = createAxios();
  const user = JSON.parse(localStorage.getItem("user"));
  let urlPath = `customer/${user.extraData.customerId}/import_data_files/${batch['processId']}?filename=${batch['filename']}`;
  return axios.get(urlPath, {
    responseType: 'blob'
  });
}

export const batchLoadsService = { getBatchLoadsList, downloadResource };